import { User } from "shared/providers/context/types/auth-context";

import { AdvancedMatching } from "@matheuscampos_450/react-facebook-pixel";

import { TClassName, TEntityType, TPaymentMethod } from "./index.d";
import { fetchPixelRequest } from "./services";

export const getEntityType = (className: TClassName): TEntityType => {
  let entityType: TEntityType;

  if (className.includes("Course")) {
    entityType = "course";
  } else if (className.includes("DesktiPlanModelsPlan")) {
    entityType = "plan";
  } else if (className.includes("MediaSpaceContent")) {
    entityType = "media-space";
  } else if (className.includes("ProductBundle")) {
    entityType = "bundle";
  } else if (className.includes("Group")) {
    entityType = "group";
  }

  return entityType;
};

export const getPixelData = async (
  pixelResponse,
  className,
  slug,
  promoterLink = null,
) => {
  let data = [];

  if (!pixelResponse || pixelResponse?.length === 0) {
    data = await fetchPixelRequest(className, slug, promoterLink);
  } else {
    data = pixelResponse;
  }
  return data;
};

export const getAdvancedMatching = (
  loggedUser: User,
): AdvancedMatching | null => {
  if (loggedUser) {
    const address = loggedUser?.addresses?.at(0);
    const phone = loggedUser?.phones?.at(0);

    const advancedMatching: AdvancedMatching = {
      em: loggedUser?.email?.toLowerCase(),
      fn: loggedUser?.first_name?.toLowerCase(),
      ln: loggedUser?.last_name?.toLowerCase(),
      country: address?.country,
      ct: address?.city,
      db: null,
      ge: null,
      ph: phone?.full_number,
      st: address?.state,
      zp: address?.zipcode,
    };
    return advancedMatching;
  }

  return null;
};

export const getTrackData = (payload) => {
  const utms = JSON.parse(sessionStorage.getItem("utms"));

  if (!!payload?.contents) {
    const trackData = {
      currency: payload?.currency,
      content_type: payload?.className,
      contents: payload?.contents,
      payment_type: payload?.paymentMethod,
      num_items: payload?.num_items,
    };
    if (payload?.fbc) trackData["fbc"] = payload.fbc;
    if (payload?.fbp) trackData["fbp"] = payload.fbp;
    if (utms) {
      Object.assign(trackData, utms);
    }

    return trackData;
  }

  if (payload.paymentMethod) {
    const trackData = {
      value: payload.value,
      currency: payload.currency,
      content_ids: payload.productId,
      content_type: payload.className,
      content_name: payload.productName,
      payment_type: payload.paymentMethod,
    };

    if (payload?.fbc) trackData["fbc"] = payload.fbc;
    if (payload?.fbp) trackData["fbp"] = payload.fbp;
    if (payload?.offer_name) trackData["offer_name"] = payload?.offer_name;

    if (utms) {
      Object.assign(trackData, utms);
    }

    return trackData;
  }

  if (payload.value) {
    const trackData = {
      value: payload.value,
      currency: payload.currency,
      content_ids: payload.productId,
      content_type: payload.className,
      content_name: payload.productName,
    };

    if (payload?.fbc) trackData["fbc"] = payload.fbc;
    if (payload?.fbp) trackData["fbp"] = payload.fbp;
    if (payload?.offer_name) trackData["offer_name"] = payload?.offer_name;

    if (utms) {
      Object.assign(trackData, utms);
    }

    return trackData;
  }

  const trackData = {
    content_ids: payload.productId,
    content_type: payload.className,
    content_name: payload.productName,
  };
  if (payload?.fbc) trackData["fbc"] = payload.fbc;
  if (payload?.fbp) trackData["fbp"] = payload.fbp;

  if (utms) {
    Object.assign(trackData, utms);
  }

  return trackData;
};

export const isDisabled = (pixelItem, paymentMethod: TPaymentMethod) => {
  const { track_boleto, track_credit_card, track_pix } = pixelItem;

  if (!track_boleto && !track_credit_card && !track_pix) return true;

  switch (paymentMethod) {
    case "credit_card":
      return !track_credit_card;
    case "bank_slip":
      return !track_boleto;
    case "pix":
      return !track_pix;

    default:
      return false;
  }
};
